import React, { useState } from 'react';
import authService from '../services/authService';
import { TENANT_DB_NAME } from '../services/api';
import Logo from '../components/Logo';

const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!TENANT_DB_NAME) {
      setError('Missing practice context. Check this deployment’s config.js (TENANT_DB).');
      return;
    }
    if (!username || !password) {
      setError('Please enter your username and password.');
      return;
    }

    setLoading(true);
    try {
      const response = await authService.login(username, password);
      if (response.data && response.data.userFound) {
        onLoginSuccess();
      } else {
        setError(response.data?.err || 'Invalid username or password.');
      }
    } catch (err) {
      setError('Login failed: ' + (err.response?.data?.err || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-brand-gradient-deep font-sans px-4">
      <div className="w-full max-w-[440px] bg-white p-10 rounded-2xl shadow-2xl border border-white/20">
        <div className="text-center mb-8">
          <Logo className="h-10 w-auto mx-auto" />
          <p className="mt-3 text-slate-500 text-sm">
            Sign in to <span className="font-semibold text-brand-navy">{TENANT_DB_NAME}</span>
          </p>
        </div>

        <form onSubmit={handleLogin} className="flex flex-col gap-5">
          <div className="flex flex-col gap-2">
            <label className="text-[0.85rem] font-semibold text-slate-600" htmlFor="uname">
              Username or Email
            </label>
            <input
              id="uname"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="p-2.5 rounded-lg border border-slate-300 text-base outline-none transition-shadow focus:border-brand-navy focus:ring-2 focus:ring-brand-teal/40"
              placeholder="Enter your username or email"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[0.85rem] font-semibold text-slate-600" htmlFor="upasswd">
              Password
            </label>
            <input
              id="upasswd"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="p-2.5 rounded-lg border border-slate-300 text-base outline-none transition-shadow focus:border-brand-navy focus:ring-2 focus:ring-brand-teal/40"
              placeholder="Enter your password"
            />
          </div>

          {error && <div className="text-red-600 text-[0.85rem] text-center">{error}</div>}

          <button
            type="submit"
            disabled={loading}
            className="mt-1 p-3 bg-brand-gradient text-white border-none rounded-lg text-base font-semibold cursor-pointer transition-opacity hover:opacity-95 disabled:opacity-60"
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div className="text-center mt-6">
          <a href="http://localhost:2100" className="text-slate-400 text-xs hover:text-brand-navy">
            &larr; Back to omniprac.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
